<template>
	<div>
		<!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
		<CCard>

			<CCardBody>
				<CDataTable :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed"
					:items="items" :fields="fields" :items-per-page="small ? 5 : 5" :dark="dark" pagination tableFilter
					sorter itemsPerPageSelect>
					<template #checkbox="{ item }">
						<td>
							<Input type="checkbox" class="check_calculate" :id='"check_" + item.Invoice_No'
								@change="getPaid()" :invoice_date='item.Invoice_Date'
								:Invoice_Amount='item.Invoice_Amount' :Outstanding_Amount='item.OutStanding_Amount' />
						</td>
					</template>
					<template #status="{ item }">
						<td>
							<CBadge :color="getBadge(item.status)">{{ item.status }}</CBadge>
						</td>
					</template>
					<template #Paid_Amount="{ item }">
						<td>
							<Input type="text" placeholder="Paid Amount" class="Paid_calculate"
								:id='"paid_" + item.Invoice_No' v-on:keyup="getPaid" />
						</td>
					</template>
					<template #TDS="{ item }">
						<td>
							<Input placeholder="TDS" class="TDS_calculate" :id='"tds_" + item.Invoice_No'
								v-on:keyup="getPaid" />
						</td>
					</template>
					<template #Balance_Amount="{ item }">
						<td>
							<label class="m-0 col-fonts-black" :id='"bal_" + item.Invoice_No'>0.00</label>
						</td>
					</template>
				</CDataTable>
				<CCol sm="12 d-flex">
					<CCol sm="6 d-flex">
					</CCol>
					<CCol sm="6 d-flex">
						<CCol sm="6">
							<CInput label="UTR NO/Cheque No" type="text" value="" id="cheque_no" />
						</CCol>
						<CCol sm="6">
							<CInput label="Payment Date" type="date" :min="currentdate" :value="currentdate"
								id="payment_date" />
						</CCol>
					</CCol>
				</CCol>
				<CCol sm="12 d-flex">
					<CCol sm="6 d-flex">
					</CCol>
					<CCol sm="6 d-flex">
						<CCol sm="6" id="isShowRemarkBox">
							<CTextarea label="Remarks" id="Remarks" :value="Remarks" verticle rows="4" />
						</CCol>
						<CCol sm="6">
							<CCol sm="12 mt-10">
								<label class="m-0 col-fonts-black">Total Payment: <span id="total_pay"
										class="fw-bold">{{ total_pay }}</span></label>
							</CCol>
							<CCol sm="12 mt-10">
								<label class="m-0 col-fonts-black">Total TDS: <span id="total_tds" class="fw-bold">{{
										total_tds
								}}</span></label>
							</CCol>
							<CCol sm="12 mt-10">
								<button aria-pressed="true" type="button" autocomplete="off"
									class="btn btn-outline-info btn-block active fw-500 col-white fs-18"
									@click="submit()">Submit</button>
							</CCol>
						</CCol>
					</CCol>
				</CCol>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
import axios from "axios";
export default {
	name: 'Payment_advice',
	data() {
		return {
			plantcodeOptions: [],
			currentdate: '',
			Remarks: '',
			total_pay: '0.00',
			total_tds: '0.00',
			isLoading: false,
			isShowRemarks: false
		}
	},

	props: {
		items: Array,
		fields: {
			type: Array,
			default() {
				return ['checkbox', 'Invoice_No', 'Invoice_Date', 'Invoice_Amount', 'OutStanding_Amount', 'Paid_Amount', 'TDS', 'Balance_Amount']
			}
		},
		hover: Boolean,
		striped: Boolean,
		bordered: Boolean,
		small: Boolean,
		fixed: Boolean,
		dark: Boolean
	},
	mounted() {
		var self = this;
		var today = new Date();
		// var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
		var date = today.getFullYear() + '-' + ((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' + (today.getDate() < 10 ? '0' + today.getDate() : today.getDate());
		this.currentdate = date;
		$('#isShowRemarkBox').hide();

	},
	computed: {

	},
	methods: {
		addData(data) {
			var self = this;
			var config = {
				method: 'post',
				url: apiURL + 'CustPaymentAdvice/AddCustomerPaymentDetails',
				headers: {
					'Content-Type': 'application/json'
				},
				data: data
			};
			this.isLoading = true;
			axios(config)
				.then((result) => {
					this.isLoading = false;
					if (result.data.status_code == 200) {
						if (result.data.status_code == 200) {
							var obj = result.data.response;
							this.$swal.fire({
								icon: 'success',
								title: 'Save',
								text: 'Data added successfully..'
							})
						} else {
							this.$swal.fire({
								icon: 'error',
								title: 'Oops...',
								text: 'Something went wrong!'
							})
						}
					}
				})
				.catch((error) => {
					this.isLoading = false;
					this.$swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'Something went wrong!'
					})
				});
		},
		getPaid(is_submit = false) {
			var total_pay = 0;
			var total_tds = 0;
			var self = this;
			$(".check_calculate").each(function () {
				var ids = $(this).attr('id');
				var inputid = ids.split('_');
				var rowid = inputid[1];
				var isChecked = $("#check_" + rowid).is(":checked");
				// for show remark box
				let newOutStandingVal = $(this).attr('Outstanding_Amount')
				let newOutpaid = $("#paid_" + rowid).val() + '.00'
				if (parseInt(newOutStandingVal) < parseInt(newOutpaid)) {
					$('#isShowRemarkBox').show();
				} else {
					$('#isShowRemarkBox').hide();
				}
				// second conition for show remarks
				var newInvoiceAmount = $('#check_' + rowid).attr('invoice_amount');
				if (parseInt(newInvoiceAmount) < parseInt(newOutpaid)) {
					$('#isShowRemarkBox').show();
				} else {
					$('#isShowRemarkBox').hide();
				}

				if (isChecked) {
					var paidval = $("#paid_" + rowid).val();
					if (paidval != '') {
						var Outstanding_Amount = $(this).attr('Outstanding_Amount');
						var bal_amt = (Outstanding_Amount - paidval).toFixed(2);
						$("#bal_" + rowid).html(bal_amt);
						total_pay += parseFloat(paidval);
					} else {
						$("#bal_" + rowid).html('0.00');
					}

					var tdsval = $("#tds_" + rowid).val();
					if (tdsval != '') {
						total_tds += parseFloat(tdsval);
					}


					if (is_submit == true) {

						var Plant_Code = localStorage.getItem("pay_Plant_Code");
						var Customer_Code = localStorage.getItem("pay_Customer_Code");
						var Customer_Name = localStorage.getItem("pay_Customer_Name");

						var invoice_date = $('#check_' + rowid).attr('invoice_date');
						var invoice_amount = $('#check_' + rowid).attr('invoice_amount');
						var outstanding_amount = $('#check_' + rowid).attr('outstanding_amount');

						var Paid_Amount = parseFloat($("#paid_" + rowid).val());
						var Paid_TDS = parseFloat($("#tds_" + rowid).val());

						var cheque_no = $('#cheque_no').val();
						var payment_date = $('#payment_date').val();
						var payment_datesplit = payment_date.split('-');
						var payment_date = payment_datesplit[2] + '-' + payment_datesplit[1] + '-' + payment_datesplit[0];
						var Remarks = $('#Remarks').val();
						var Token = localStorage.getItem("auth");
						var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
						var requestInfo = {
							Plant_Code: Plant_Code,
							Customer_Code: Customer_Code,
							Customer_Name: Customer_Name,
							Invoice_No: rowid,
							Invoice_Date: invoice_date,
							Invoice_Amount: invoice_amount,
							Outstanding_Amount: outstanding_amount,
							Paid_Amount: '' + Paid_Amount + '',
							Paid_TDS: '' + Paid_TDS + '',
							UTR_Cheque_No: cheque_no,
							Payment_Date: payment_date,
							Remarks: Remarks,
							Token: Token,
							Session_User_Id: Session_User_Id,
						};
						var data = JSON.stringify(requestInfo);
						self.addData(data);
					}
				} else {
					var paidval = $("#paid_" + rowid).val();
					if (paidval != '') {
						var Outstanding_Amount = $(this).attr('Outstanding_Amount');
						var bal_amt = (Outstanding_Amount - paidval).toFixed(2);
						$("#bal_" + rowid).html(bal_amt);
					} else {
						$("#bal_" + rowid).html('0.00');
					}
				}
			});
			self.total_pay = total_pay.toFixed(2);
			self.total_tds = total_tds.toFixed(2);
		},
		submit() {
			var self = this;
			var totcheck = 0;
			var totpayfalse = 0;
			var tottdsfalse = 0;
			$(".check_calculate").each(function () {
				var isChecked = $(this).is(":checked");
				if (isChecked) {
					var ids = $(this).attr('id');
					var inputid = ids.split('_');
					var rowid = inputid[1];
					var paidval = $("#paid_" + rowid).val();
					if (paidval == '' || paidval == null) {
						totpayfalse++;
					}

					var tdsval = $("#tds_" + rowid).val();
					if (tdsval == '' || tdsval == null) {
						tottdsfalse++;
					}
					//console.log(rowid);
					totcheck++;
				}
			});
			//console.log(totpayfalse);
			if (parseFloat(totpayfalse) > 0) {
				self.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Please enter paid amount..!'
				});
				return false;
			}
			if (parseFloat(tottdsfalse) > 0) {
				self.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Please enter TDS..!'
				});
				return false;
			}
			if (parseFloat(totcheck) <= 0) {
				self.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Please select invoice..!'
				});
				return false;
			}

			var cheque_no = $('#cheque_no').val();
			if (cheque_no == '') {
				self.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Cheque no is required..!'
				})
				return false;
			}
			this.getPaid(true);
		}
	}
}
</script>
